import {segment} from './helpers'

export const eventMgrLinkClicked = (targetLinkName) => {
  segment('Clicked Event Manager Link', {
    currentPath: window.location.pathname,
    targetLinkName,
  })
}
